<template>
  <div class="vx-row mb-2" v-if="showDataField">
    <div class="vx-col w-full">
      <vs-divider>{{structure.label}}</vs-divider>

      <vs-row class="p-2">
        <vs-col
          class="font-semibold p-2"
          vs-type="flex"
          :vs-w="structure.width"
          v-for="(val,id) in structure.data"
          :key="id"
        >
          <vs-radio v-model="selected" :vs-value="index+val">{{val}}</vs-radio>
        </vs-col>
      </vs-row>

      <vs-row class="p-2" v-show="selected == index+structure.showTextBoxWhenValueIs">
        <vs-col class="font-semibold p-2" vs-type="flex">
          <vs-input
            class="w-full"
            v-validate="'required'"
            :label-placeholder="structure.showTexboxLabel"
            v-model="others"
            name="field"
            @keyup="changeHandler"
          />
        </vs-col>
      </vs-row>
      <vs-row class="p-2" v-show="selected == index+structure.showTextBoxWhenValueIs">
        <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
      </vs-row>
    </div>
  </div>
</template> 
<script>
import { helperMixin } from "../../../mixin/helperMixin";
import { sidebarMixin } from "../sidebarMixin";

import { bus } from "../../../main";
export default {
  components: {},
  mixins: [helperMixin, sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true
    },
    value: String,
    validation: ""
  },
  data() {
    return {
      selected: this.thevalue,
      others: "",
      currentValueOfShowHideField: true //this is to retain the current value of show and hide
    };
  },
  computed: {
    thevalue() {
      return this.value;
    },
    showDataField() {
      return this.showField();
    }
  },
  methods: {
    changeHandler() {
      this.$emit("input", {
        index: this.index,
        value: this.others
      });

      this.$validator.validateAll().then(result => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
    test(val) {
      console.log("valOf radio:", val);
    }
  },
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    //assigne the selected value
    this.selected = this.index + this.thevalue;

    //event bus for hiding and showing field based on other field
    bus.$emit("showHideField", {
      index: this.index,
      value: this.value
    });

    //check for other's value
    if (this.value == undefined || this.value == "") {
      this.selected = this.index + this.structure.defaultValue; //assigning the default value
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", {
        index: this.index,
        value: this.structure.defaultValue
      });

      //event bus for hiding and showing field based on other field
      bus.$emit("showHideField", {
        index: this.index,
        value: this.structure.defaultValue
      });
    } else {
      if (!this.arrayFind(this.structure.data, this.value)) {
        if (this.isset(this.structure, "showTextBoxWhenValueIs")) {
          this.selected = this.index + this.structure.showTextBoxWhenValueIs;
          this.others = this.value;
        } else {
          console.log(
            "Missing Property: showTextBoxWhenValueIs for:" +
              this.index +
              " value:" +
              this.value
          );
        }
      } else {
      }
    }

    //defined the watch method
    this.$watch("selected", value => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
      }

      //event bus for hiding and showing field based on other field
      bus.$emit("showHideField", {
        index: this.index,
        value: value.replace(this.index, "")
      });

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", {
        index: this.index,
        value: value.replace(this.index, "")
      });
    });
  }
};
</script>